import { useUser } from '@myosh/myosh-login';
import { type ImperativePanelGroupHandle, ResizablePanel, ResizablePanelGroup } from '@myosh/odin-components';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useLoginQueryParams } from '../../hooks/useLoginQueryParams';
import { useAppSelector } from '../../redux/hooks';
import { setSchemaInfo } from '../../redux/slices/globalFilter/GlobalFilterHierarchySlice';
import { selectSidePanelFullScreen } from '../../redux/slices/side-panel-slice';
import ActiveSidePanel from '../SidePanel/side-panel.component';

export const PrivateRoute = () => {
  const { state } = useUser();
  const isAuthenticated = state.auth;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { username } = useLoginQueryParams();
  const isSidePanelFullScreen = useAppSelector(selectSidePanelFullScreen);

  const panelGroupRef = useRef<ImperativePanelGroupHandle>(null);

  useEffect(() => {
    if (state?.user?.schemas) {
      dispatch(setSchemaInfo(state.user.currentSchema));
    }
  }, [state, dispatch]);

  if (isAuthenticated) {
    return (
      <ResizablePanelGroup ref={panelGroupRef} autoSaveId="dashboard" direction="horizontal">
        <ResizablePanel
          id="main-layout"
          order={1}
          className={clsx({
            'hidden overflow-hidden pointer-events-none': isSidePanelFullScreen,
          })}
        >
          <Outlet />
        </ResizablePanel>
        <ActiveSidePanel />
      </ResizablePanelGroup>
    );
  } else if (!isAuthenticated && !pathname.includes('/login')) {
    return <Navigate to={username ? `/login?username=${username}` : '/login'} />;
  }

  return null;
};
